export default __webpack_public_path__ + "static/media/placeholder-image.76a6f08d.jpg";